// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2D6wB","label":"CategoryService_label__KH4Qw","location":"CategoryService_location__3PxgS"};